import React from 'react';
import CusTooltip from '../../material-ui/CusTooltip';
import { ENUM_BONUS_ID } from '../../../enums/MenuItems';

export default function BonusInfoTooltip({ id, isNodeGroup }) {
  const getTooltipText = () => {
    if (id == ENUM_BONUS_ID.promocode) {
      if (isNodeGroup)
        return 'The generated promo code is valid for players of the current and ALL subsidiary groups.';
      return 'The generated promo code is valid only for players in the current Game Group.';
    }

    if (id == ENUM_BONUS_ID.jackpots) {
      if (isNodeGroup)
        return 'Jackpots are only active if they are set in a Game Group and only for players in that group. Check the corresponding box if you want to copy the current settings to subgroups.';
      return 'Jackpots are valid only for players in the current Game Group.';
    }

    if (id == ENUM_BONUS_ID.welcome) {
      if (isNodeGroup)
        return "The welcome bonus is only valid if it's set in a Game Group and only for players in that group. Check the corresponding box if you want to copy the current settings to subgroups.";
      return 'The welcome bonus is valid only for players in the current Game Group.';
    }

    if (id == ENUM_BONUS_ID.cashback) {
      if (isNodeGroup)
        return "The cashback bonus is only valid if it's set in a Game Group and only for players in that group. Check the corresponding box if you want to copy the current settings to subgroups.";
      return 'The cashback bonus is valid only for players in the current Game Group.';
    }

    if (id == ENUM_BONUS_ID.freespin) {
      return 'The created Freespin is valid only for players of the current Game Group.';
    }

    if (id == ENUM_BONUS_ID.launch_bot) {
      return "The 'Bot Launch' bonus is valid only for players in the current Game Group.";
    }

    if (id == ENUM_BONUS_ID.phone_bot) {
      return "The 'Start for Phone in Bot' bonus is only valid for players in the current Game Group.";
    }
  };

  const textTooltip = getTooltipText();
  return <CusTooltip text={textTooltip} />;
}
